import { baseAPIRequest } from 'utilities/http';

async function getProductDeliveryDates (shortSkus, usePostalCode = false, quantity = 1) {

	if (!shortSkus || shortSkus.length === 0 || !Array.isArray(shortSkus)) {

		console.warn('getProductDeliveryDates: Invalid input. Expected an array of short SKUs.');
		return;

	}

	try {

		const response = await baseAPIRequest({
			url: '/api/product-shipping/multiple-product-delivery-date/',
			data: {
				ShortSkus: shortSkus,
				Quantity: quantity,
				UseProductDetailPostalCode: usePostalCode
			},
			params: { method: 'POST' }
		});
		return response;

	} catch (error) {

		console.log(error);

	}

}

export default getProductDeliveryDates;
